import { Box, Grid } from '@mui/material';
import FormView from '../../../../components/views/formView';
import { usePqrReceivedThroughForm } from './hook';
import { SuptypeDPData } from './data';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import {
    PQR_RECEIVED_THROUGH,
    PQR_RECEIVED_THROUGH_DETAIL,
    PQR_RECEIVED_THROUGH_EDIT,
    PQR_RECEIVED_THROUGH_NEW,
} from '../../../../../routes/paths';
import { PqrReceivedThroughParamsHistorical } from '../historical';

export const PqrReceivedThroughForm = () => {
    const {
        pqrReceivedThrough,
        loading,
        handleSubmit,
        handleCleanAndBack,
        setFormikPqrReceivedThroughData,
        pqrReceivedThroughHistorical,
        showHistorical,
        setShowHistorical,
    } = usePqrReceivedThroughForm();

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <FormView
                title={
                    pqrReceivedThrough && pqrReceivedThrough.id
                        ? 'Editar medio PQR'
                        : 'Crear medio PQR'
                }
                additionalButtons={
                    <ActionButtonGroup
                        id={pqrReceivedThrough?.id || ''}
                        buttonCreate={{
                            show: Boolean(pqrReceivedThrough?.id),
                            route: PQR_RECEIVED_THROUGH_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: PQR_RECEIVED_THROUGH,
                        }}
                        buttonUpdate={{
                            show: true,
                            route: PQR_RECEIVED_THROUGH_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: PQR_RECEIVED_THROUGH_DETAIL,
                        }}
                        buttonLog={{
                            show: Boolean(pqrReceivedThrough?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            />
            {showHistorical && (
                <Box sx={{ marginTop: 2 }}>
                    <PqrReceivedThroughParamsHistorical
                        historical={pqrReceivedThroughHistorical ?? []}
                        showHistorical={true}
                    />
                </Box>
            )}
            <SuptypeDPData
                data={pqrReceivedThrough}
                onChangeFormik={(formik) =>
                    setFormikPqrReceivedThroughData(formik)
                }
            />
            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Volver"
                    variant="outlined"
                    onClick={handleCleanAndBack}
                />
            </Grid>
        </>
    );
};
